var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"support"}},[_c('div',{staticClass:"videoArea"},[_c('iframe',{ref:"intro",attrs:{"src":_vm.videoURL,"frameborder":"0","width":"100%","allowfullscreen":"","allow":"accelerometer;"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }